// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__2zchS","description":"PatientConsentPreview_description__cEEqI"};